<ng-container *ngIf="action$ | async"></ng-container>

<div mat-dialog-title>
  <div i18n class="title dialog-title">Рекомендуемая облицовка</div>
  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="no-padding">
  <csl-edges-in-color
    [materialInMatBaseId]="data.materialInMatBaseId"
    [panelThickness]="data.panelThickness"
    [showQuantityInStock]="data.showQuantityInStock"
    (selectionChange)="this.selectedEdge = $event[0]"
    (selectedFromMatBase)="saveAndClose($event)"/>
</mat-dialog-content>

<div mat-dialog-actions>
  <button i18n mat-raised-button class="mat-accent" (click)="saveAndClose()">ОК</button>
  <button i18n mat-button [mat-dialog-close]>ОТМЕНА</button>
</div>
